import { useNavigate } from 'react-router-dom';
import { FaApple, FaFacebookF, FaGoogle } from 'react-icons/fa';

export default function RightLoginForm() {
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    navigate('/broker-connect');
  };

  return (
    <div className="w-full max-w-md bg-white p-8 rounded-2xl shadow-lg">
      <h2 className="text-3xl font-semibold text-center mb-6">Log in</h2>
      {/* Self-registration is closed — no Sign up link. */}
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          placeholder="username"
          className="w-full p-3 border border-gray-300 rounded-lg placeholder-gray-500"
          required
        />
        <input
          type="password"
          placeholder="password"
          className="w-full p-3 border border-gray-300 rounded-lg placeholder-gray-500"
          required
        />
        <div className="flex items-center space-x-2">
          <input type="checkbox" id="remember" className="w-4 h-4" />
          <label htmlFor="remember" className="text-sm text-gray-600">Remember me</label>
        </div>
        <button
          type="submit"
           className="w-full bg-[#8e44ec] hover:bg-[#7d3ccf] text-white p-3 rounded-lg font-semibold"
        >
          Log in
        </button>
      </form>
      {/* <div className="text-center mt-4 text-sm text-gray-500">
        Forgot <a href="#" className="text-blue-600 underline">Username</a> / <a href="#" className="text-blue-600 underline">Password?</a>
      </div>
      <div className="flex items-center my-6">
        <hr className="flex-grow border-gray-300" />
        <span className="mx-4 text-sm text-gray-400">OR SIGN IN WITH SOCIALS</span>
        <hr className="flex-grow border-gray-300" />
      </div>
      <div className="flex justify-center space-x-6">
        <FaApple className="w-6 h-6 cursor-pointer text-gray-700" />
        <FaFacebookF className="w-6 h-6 cursor-pointer text-blue-600" />
        <FaGoogle className="w-6 h-6 cursor-pointer text-red-500" />
      </div> */}
    </div>
  );
}